// extracted by mini-css-extract-plugin
export default {"ageOnSetInput":"LifeStageAgeMode_ageOnSetInput__g2-K7","ageOnSetSelectBox":"LifeStageAgeMode_ageOnSetSelectBox__MnT8j"};